export default __webpack_public_path__ + "static/media/location_preview_s3_forgotten_forest.e5dc27a1.svg";